import {isFeatureEnabled} from '@github-ui/feature-flags'
import {FallbackEvent} from '@github-ui/timeline-items/FallbackEvent'
import {TimelineRowBorder} from '@github-ui/timeline-items/TimelineRowBorder'
import {TimelineRowPassthroughContext} from '@github-ui/timeline-items/TimelineRowPassthroughContext'

import {computeFailedLoadRowPassthrough} from './compute-event-row-passthrough'

/**
 * A timeline item component that represents a failed load event.
 *
 * This component is a parity item for TimelineItems, created as part of the issues_react_new_timeline feature flag work.
 * https://github.com/github/github/blob/50680482a2fc6c0d2a13c36e34893433d205e986/ui/packages/issue-viewer/components/TimelineItems.tsx#L384
 */
export const FailedLoadTimelineItem = () => {
  // Under primer_react_timeline_list_semantics this row must be an <li> that is a
  // direct child of the parent <ol>. FallbackEvent renders a TimelineRow whose
  // Timeline.Item already is that <li>, so we return it directly and skip the
  // TimelineRowBorder <div> wrapper. The passthrough restores the divider, the
  // .default indent, data-timeline-event-id, and the test id that the flag-off
  // TimelineRowBorder carried. Flag-off keeps the existing wrapped markup.
  if (isFeatureEnabled('primer_react_timeline_list_semantics')) {
    return (
      <TimelineRowPassthroughContext value={computeFailedLoadRowPassthrough()}>
        <FallbackEvent />
      </TimelineRowPassthroughContext>
    )
  }

  return (
    <TimelineRowBorder addDivider item={{__id: `failed-timeline-item`}}>
      <FallbackEvent />
    </TimelineRowBorder>
  )
}
